import { Tab, Tabs } from "@mui/material";
import typography from "../../theme/typography";
import { useTranslation } from "react-i18next";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const GoStarTabs = ({
  tabValue,
  handleChangeTabValue,
  isLoading,
  setIsLoading,
}: {
  tabValue: number;
  handleChangeTabValue: (event: React.SyntheticEvent, newValue: number) => void;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={tabValue}
      onChange={handleChangeTabValue}
      aria-label="basic auto tabs"
      sx={{
        minHeight: "unset",
        "& .MuiTabs-flexContainer": {
          gap: "16px",
        },
        "& .MuiTabs-indicator": {
          height: "3px",
        },
      }}
    >
      <Tab
        label={t("pages.goStar.trending")}
        {...a11yProps(0)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
      <Tab
        label={t("pages.goStar.verified")}
        {...a11yProps(1)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
    </Tabs>
  );
};

export default GoStarTabs;
